//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

export const GRAPH_API_HASHTAG_LIMIT = 30;
angular.module('curalate').constant('GRAPH_API_HASHTAG_LIMIT', GRAPH_API_HASHTAG_LIMIT);
